export default __webpack_public_path__ + "static/media/moolchand.fdd24f5d.jpg";